<script lang="ts">
	import { type Snippet } from 'svelte';
	import type { ClassValue } from 'svelte/elements';

	interface Props {
		play: boolean;
		index?: number;
		children?: Snippet;
		class?: ClassValue;
	}

	const PIXEL_FACTOR = 8;
	const DELAY_FACTOR = 10;
	const DELAY_OFFSET = 20;

	let { play, index = 0, children, class: className }: Props = $props();
</script>

<div
	class={['fly-in-transition transition-transform duration-300 lg:duration-500', className]}
	style="--transition-delay: {play
		? DELAY_OFFSET + DELAY_FACTOR * index
		: 0}ms; --transition-y: {play ? 0 : -PIXEL_FACTOR * (index + 1)}px;"
>
	<div
		class={[
			'flex transition-opacity',
			play ? 'opacity-100  delay-100 duration-[480ms]' : 'opacity-0 duration-[145ms]'
		]}
	>
		{@render children?.()}
	</div>
</div>

<style lang="scss">
	.fly-in-transition {
		transform: translate3d(0, var(--transition-y), 0);
		transition-delay: var(--transition-delay);
	}
</style>
